import _ from 'lodash';
import moment from 'moment-timezone';
import { SELECTION_COLORS } from './const';
export const activityLogFilterValues = [
    'calendarId',
    'startTime',
    'endTime',
    'title',
    'assignedUserId',
    'notes',
    'appoinmentStatus',
    'address',
    'google',
    'outlook',
];
export const activityLogFilterLabels = (t) => {
    return {
        calendarId: t('activity_log.calendar_update'),
        startTime: t('activity_log.start_time_update'),
        endTime: t('activity_log.end_time_update'),
        title: t('activity_log.title_update'),
        notes: t('activity_log.notes_update'),
        appoinmentStatus: t('activity_log.appointment_status_update'),
        address: t('activity_log.meeting_location_update'),
        google: t('activity_log.google_sync_update'),
        outlook: t('activity_log.outlook_sync_update'),
        assignedUserId: t('activity_log.assigned_user_update'),
    };
};
export const getRecurringFrequency = (frequency) => {
    switch (frequency) {
        case 'DAILY':
            return 'Daily';
        case 'WEEKLY':
            return 'Weekly';
        case 'MONTHLY':
            return 'Monthly';
    }
};
export const isMeetingURLValid = (url) => {
    const pattern = new RegExp('^([a-zA-Z]+:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR IP (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', // fragment locator
    'i');
    // Patterns for meeting URL for zoom / google/ outlook
    const zoomPattern = /zoom.us\//i;
    const googleMeetPattern = /meet.google.com\//i;
    const outlookPattern = /outlook\.office\.com\/(?:[^/]+\/){6}join/i;
    return (pattern.test(url) &&
        (zoomPattern.test(url) ||
            googleMeetPattern.test(url) ||
            outlookPattern.test(url)));
};
export const convertAndFormatSource = (inputString) => {
    if (inputString && (inputString.includes('_') || inputString.includes('-'))) {
        // Choose the separator based on whether underscore or hyphen is present
        const separator = inputString.includes('_') ? '_' : '-';
        // Split the string into words using the chosen separator as separators
        const words = inputString.split(separator);
        // Capitalize the first letter of each word and join them with spaces
        const formattedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
        const formattedString = formattedWords.join(' ');
        return formattedString;
    }
    else {
        return inputString;
    }
};
export function convertEvents(data, timezone) {
    try {
        const result = [];
        data.map((item) => {
            const ob = Object.assign(Object.assign({}, item), { id: '', start: '', end: '', title: '', icon: '', timeString: '', eventId: '', editable: false, setAllDay: false });
            ob.id = _.uniqueId(item.id + '_'); // FC Calendar wants the Ids to be unique
            ob.eventId = item.id;
            ob.start = moment.tz(item.startTime, timezone).format();
            ob.end = moment.tz(item.endTime, timezone).format();
            ob.editable = ob.local; // PREVENT 3RD PARTY EVENTS FROM BEING DRAGGED OR RESIZED
            ob.allDay = ob.isFullDay;
            ob.title = item.title;
            ob.icon = 'https://cdn-icons-png.flaticon.com/512/2504/2504739.png';
            ob.timeString = `${moment
                .tz(item.startTime, timezone)
                .format('hh:mm A')} - ${moment
                .tz(item.endTime, timezone)
                .format('hh:mm A')}`;
            result.push(ob);
        });
        return result;
    }
    catch (e) {
        //
    }
}
export const sample = [
    {
        start: '2023-09-14T04:00:00-07:00',
        end: '2023-09-14T05:00:00-07:00',
        title: 'Recurr test',
    },
    {
        start: '2023-09-11T20:30:00-07:00',
        end: '2023-09-11T21:00:00-07:00',
        title: 'Rehan Alam',
    },
    {
        start: '2023-09-14T03:00:00-07:00',
        end: '2023-09-14T04:00:00-07:00',
        title: 'Test',
    },
];
export const renderDropdownOption = (data, h, icon) => {
    return h('div', {
        style: 'display: flex; align-items: center; padding: 8px 12px;',
    }, [
        h(icon, {
            round: true,
            style: 'margin-right: 12px;',
            src: 'https://07akioni.oss-cn-beijing.aliyuncs.com/demo1.JPG',
        }),
        h('div', null, [
            h('div', null, [
                h('p', { depth: 2 }, { default: () => 'A worker at Hangzhou' }),
            ]),
        ]),
    ]);
};
export function changeOpacity(hexCode, opacity) {
    if (!hexCode)
        return hexCode;
    if (opacity === 0)
        return '#00000000';
    if (opacity === 1)
        return hexCode;
    opacity = Math.min(1, Math.max(0, opacity));
    hexCode = hexCode.replace(/^#/, '');
    if (hexCode.length === 8) {
        const r = parseInt(hexCode.slice(0, 2), 16);
        const g = parseInt(hexCode.slice(2, 4), 16);
        const b = parseInt(hexCode.slice(4, 6), 16);
        const newA = Math.round(opacity * 255);
        const clampedA = Math.min(255, Math.max(0, newA));
        const updatedHex = `#${r.toString(16).padStart(2, '0')}${g
            .toString(16)
            .padStart(2, '0')}${b.toString(16).padStart(2, '0')}${clampedA
            .toString(16)
            .padStart(2, '0')}`;
        return updatedHex;
    }
    else {
        const rgbHex = hexCode.slice(0, 6);
        const newA = Math.round(opacity * 255);
        const clampedA = Math.min(255, Math.max(0, newA));
        const updatedHex = `#${rgbHex}${clampedA.toString(16).padStart(2, '0')}`;
        return updatedHex;
    }
}
export function getTimeDifferenceInMin(d1, d2) {
    const t1 = moment(d1);
    const t2 = moment(d2);
    const minutes = t1.diff(t2, 'minutes');
    return Math.abs(minutes);
}
export function assignEventColor(arr) {
    return arr.map((item, index) => {
        return Object.assign(Object.assign({}, item), { eventColor: SELECTION_COLORS[index % SELECTION_COLORS.length] });
    });
}
export function showViewAppointment(e, tz, state, data) {
    if (!e || Object.keys(e).length === 0)
        return {};
    let appointment = {
        eventId: '',
        contactId: '',
        calendarId: '',
        locationId: '',
        timeZone: '',
        // title: '',
        // local: false,
        // status: '',
        // appointmentStatus: '',
        // notes: '',
        // isFree: false,
        // isRecurring: false,
        // isFullDay: false,
        // deleted: false,
        // startTime: '',
        // endTime: '',
        // dateAdded: '',
        // dateUpdated: '',
    };
    appointment.eventId = e.extendedProps.eventId;
    appointment.contactId = e.extendedProps.contactId;
    appointment.calendarId = e.extendedProps.calendarId;
    appointment.locationId = e.extendedProps.locationId;
    appointment.timeZone = tz;
    appointment = Object.assign(Object.assign({}, appointment), data);
    state.viewAppointmentModal.show = true;
    state.viewAppointmentModal.data = appointment;
}
